import { PureComponent } from 'react';
import PromotionConditions from 'Component/PromotionConditions';
import PromotionHero from 'Component/PromotionHero';
import Html from 'Component/Html';
import './Promotion.style';

class Promotion extends PureComponent {
    renderHero() {
        const {
            isLoading,
            promotion: {
                featured: {
                    text_color_list,
                    background_image_mobile_featured,
                    show_text_featured,
                } = {},
                hero: {
                    title,
                    subtitle,
                    button_text,
                    button_url_view,
                    background_color,
                    background_image,
                    background_image_mobile,
                    show_text,
                } = {}
            }
        } = this.props;

        if (isLoading) {
            return <div block="PromotionHero" mods={ { Loading: true } } />;
        }

        return (
            <PromotionHero
              renderType='view'
              title={ title }
              subtitle={ subtitle }
              button_text={ button_text }
              button_url={ button_url_view }
              background_color={ background_color }
              background_image={ background_image }
              text_color={ text_color_list }
              background_image_mobile={ background_image_mobile }
              show_text={ show_text }
              background_image_mobile_featured={ background_image_mobile_featured }
              show_text_featured={ show_text_featured }
            />
        );
    }

    renderProductList() {
        const { promotion: { products } } = this.props;

        if (!products) {
            return null;
        }

        return (
            <div block="Promotion" elem="Products">
                { <Html content={ products } /> }
            </div>
        );
    }

    render() {
        const {
            isLoading,
            promotion: {
                conditions,
                conditions_expanded,
                hero: { background_image, background_image_mobile, show_text } = {}
            } = {}
        } = this.props;

        return (
            <main block="Promotion">
                <meta property="og:image" content={background_image}/>
                { this.renderHero() }
                <div block="Promotion" elem="Container">
                    <PromotionConditions isLoading={ isLoading } conditions={ conditions } conditions_expanded={ conditions_expanded } />
                    { this.renderProductList() }
                </div>
            </main>
        );
    }
}

export default Promotion;
